import _defineProperty from "D:\\a\\1\\s\\fepu\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/defineProperty";
import { genSelectionStyle } from '../../select/style/multiple';
import { mergeToken } from '../../theme/internal';
var genSize = function genSize(token, suffix) {
  var componentCls = token.componentCls,
    selectHeight = token.selectHeight,
    fontHeight = token.fontHeight,
    lineWidth = token.lineWidth,
    calc = token.calc;
  var suffixCls = suffix ? "".concat(componentCls, "-").concat(suffix) : '';
  var height = token.calc(fontHeight).add(2).equal();
  var restHeight = function restHeight() {
    return calc(selectHeight).sub(height).sub(calc(lineWidth).mul(2));
  };
  var paddingTop = token.max(restHeight().div(2).equal(), 0);
  var paddingBottom = token.max(restHeight().sub(paddingTop).equal(), 0);
  return [genSelectionStyle(token, suffix), _defineProperty({}, "".concat(componentCls, "-multiple").concat(suffixCls), {
    paddingTop: paddingTop,
    paddingBottom: paddingBottom,
    paddingInlineStart: paddingTop
  })];
};
var genPickerMultipleStyle = function genPickerMultipleStyle(token) {
  var componentCls = token.componentCls,
    calc = token.calc,
    lineWidth = token.lineWidth;
  var smallToken = mergeToken(token, {
    fontHeight: token.fontSize,
    selectHeight: token.controlHeightSM,
    multipleSelectItemHeight: token.controlHeightXS,
    borderRadius: token.borderRadiusSM,
    borderRadiusSM: token.borderRadiusXS
  });
  var largeToken = mergeToken(token, {
    fontHeight: calc(token.multipleItemHeightLG).sub(calc(lineWidth).mul(2).equal()).equal(),
    fontSize: token.fontSizeLG,
    selectHeight: token.controlHeightLG,
    multipleSelectItemHeight: token.multipleItemHeightLG,
    borderRadius: token.borderRadiusLG,
    borderRadiusSM: token.borderRadius
  });
  return [
  // ======================== Size ========================
  genSize(smallToken, 'small'), genSize(token), genSize(largeToken, 'large'),
  // ====================== Selection ======================
  genSelectionStyle(token), _defineProperty({}, "".concat(componentCls).concat(componentCls, "-multiple"), _defineProperty(_defineProperty(_defineProperty({
    width: '100%'
  }, "".concat(componentCls, "-selector"), {
    flex: 'auto',
    padding: 0,
    '&:after': {
      margin: 0
    }
  }), "".concat(componentCls, "-selection-item"), {
    marginBlock: 0
  }), "".concat(componentCls, "-multiple-input"), {
    width: 0,
    height: 0,
    border: 0,
    visibility: 'hidden',
    position: 'absolute',
    zIndex: -1
  }))];
};
export default genPickerMultipleStyle;